const condtionOptions = [
  {
    "key": "NORMAL_PRESENTMENT",
    "text": "Normal presentment"
  },
  {
    "key": "CUSTOMER_NOT_PRESENT",
    "text": "Customer not present"
  },
  {
    "key": "UNATTENDED_TERMINAL_CAN_RETAIN_CARD",
    "text": "Unattended terminal can retain card"
  },
  {
    "key": "MERCHANT_SUSPICIOUS",
    "text": "Merchant suspicious"
  },
  {
    "key": "ELECTRONIC_CARD_REGISTER_INTERFACE",
    "text": "Electronic card register interface"
  },
  {
    "key": "CUSTOMER_PRESENT_CARD_NOT_PRESENT",
    "text": "Customer present card not present"
  },
  {
    "key": "PRE_AUTHORIZED_REQUEST",
    "text": "Pre authorized request"
  },
  {
    "key": "TELEPHONE_DEVICE_REQUEST",
    "text": "Telephone device request"
  },
  {
    "key": "MAIL_OR_TELEPHONE_ORDER",
    "text": "Mail or telephone order"
  },
  {
    "key": "SECURITY_ALERT",
    "text": "Security alert"
  },
  {
    "key": "CUSTOMER_IDENTITY_VERIFIED",
    "text": "Customer identity verified"
  },
  {
    "key": "SUSPECTED_FRAUD",
    "text": "Suspected fraud"
  },
  {
    "key": "SECURITY_REASONS",
    "text": "Security reasons"
  },
  {
    "key": "HOME_TERMINAL",
    "text": "Home terminal"
  },
  {
    "key": "ADMINISTRATION_TERMINAL",
    "text": "Administration terminal"
  },
  {
    "key": "UNATTENDED_TERMINAL_CANNOT_RETAIN_CARD",
    "text": "Unattended terminal cannot retain card"
  },
  {
    "key": "RECURRING_PAYMENT",
    "text": "Recurring payment"
  },
  {
    "key": "CVV_VALID",
    "text": "CVV valid"
  },
  {
    "key": "CVV_INVALID",
    "text": "CVV invalid"
  },
  {
    "key": "NONSECURE_ELECTRONIC_TRANSACTION",
    "text": "Nonsecure electronic transaction"
  },
  {
    "key": "SECURE_ELECTRONIC_TRANSACTION_WITH_CARDHOLDER_CERTIFICATION",
    "text": "Secure electronic transaction with cardholder certification"
  },
  {
    "key": "SECURE_ELECTRONIC_TRANSACTION_WITHOUT_CARDHOLDER_CERTIFICATION",
    "text": "Secure electronic transaction without cardholder certification"
  },
  {
    "key": "CHANNEL_ENCRYPTED_ELECTRONIC_TRANSACTION",
    "text": "Channel encrypted electronic transaction"
  },
  {
    "key": "SECURE_ELECTRONIC_TRANSACTION_WITH_DIGITAL_SIGNATURE",
    "text": "Secure electronic transaction with digital signature"
  },
  {
    "key": "DEFERRED_BILLING",
    "text": "Deferred billing"
  },
  {
    "key": "INTERNET_PINNED_DEBIT_TRANSACTION",
    "text": "Internet pinned debit transaction"
  },
]

export default condtionOptions;
